'use strict';
import {
    newModalFromString,
    newModalFromSelector
} from '../components/modal';
import ProductHelpers from './base';
import sizePanel from './sizePanel';

class SmartGiftHelper {
    constructor () {
        this.basketBeforeRemovedProduct = [];
        this.basketObserverEnabled = false;
        this.basketAlreadyFetched = false;
    }

    run () {
        $('body').on('click', '.js-smart-gift', (e) => {
            let pid = ProductHelpers.methods.getPidValue($(e.currentTarget));
            if (!ProductHelpers.isSizeSelected()) {
                sizePanel.openSizePanel(sizePanel.Types.SMARTGIFT);
            } else {
                this.addSmartGift(pid);
                this.enableAnalyticsBasketObserver();
            }
        });

        let analyticsDataButton = {
            action: '',
            skus: '',
            quantity: ''
        };
        let basketButtonsSelector = '.sidebar-widget .sidebar-continue-shopping-button,';
        basketButtonsSelector += '.sidebar-widget .widget-summary-button';
        $('body').on('click', basketButtonsSelector, (event) => {
            if (SGBasket) {
                if ($(event.currentTarget).hasClass('sidebar-continue-shopping-button')) {
                    analyticsDataButton.action = 'continue_shopping';
                } else if ($(event.currentTarget).hasClass('widget-summary-button')) {
                    analyticsDataButton.action = 'prepare_my_gift';
                }
                analyticsDataButton.skus = this.getSkus();
                analyticsDataButton.quantity = this.getSkusQuantity();
                $('body').trigger('analytics:smartGiftBasketButtons', analyticsDataButton);
            }
        });

        $('body').on('click', '.sidebar-widget .SGBasketButton', () => {
            if (SGBasket) {
                $('body').trigger('analytics:smartGiftBasketIcon');
            }
        });

        $('body').on('click', '.smart-gift-rules-label, .js-smart-gift-rules', () => {
            $('body').trigger('analytics:smartGiftMoreInfo');
        });
    };

    addRecommendedItems(data){
        var eachSuggestion = $('.box-complete-yourlook .product');
        let dataSuggestion = [];
        var suggestionLength = eachSuggestion.length > 3 ? 3 : eachSuggestion.length;
        for (var i = 0; i < suggestionLength; i++){
            let suggestionItem = {};
            let infoSuggestion = eachSuggestion[i].querySelector('.productListingItem');
            let imgSuggestion = eachSuggestion[i].querySelector('.tile-image');
            let hrefSuggestion = eachSuggestion[i].querySelector('.product-tile');
            suggestionItem.skuCode = eachSuggestion[i].dataset.pid.replace('~', '/');
            suggestionItem.name = imgSuggestion.title;
            suggestionItem.price = infoSuggestion.dataset.price;
            suggestionItem.skuUrl = hrefSuggestion.href;
            suggestionItem.image = imgSuggestion.src || imgSuggestion.dataset.src;
            dataSuggestion.push(suggestionItem);
        }
        data.recommendedItems = dataSuggestion;
    };

    addSmartGift(pid){
        let data = {};
        data.skuCode = pid.replace('~', '/');
        data.name = $('h1[itemprop="name"]').text();
        data.price = $('.product.analytics').data('price');
        data.skuUrl = window.location.href;
        data.image = $('.still-life-img').data('still-life');
        let nameEng = $('.product.analytics').data('name');
        data.nameEng = nameEng;

        this.addRecommendedItems(data);

        SGBasket.addItem(data);
        console.log(data);
        $('body').trigger('analytics:addSmartGift', { sku: data.skuCode, name: nameEng });
    };

    getSkus () {
        let skus = [];
        SGBasket.state.basket.forEach((element) => {
            skus.push(element.skuCode);
        });
        return skus;
    };

    getSkusQuantity () {
        return SGBasket.state.basket.length;
    };

    getBasket () {
        let basket = [];
        if (SGBasket) {
            SGBasket.state.basket.forEach((element) => {
                basket.push(element);
            });
            return basket;
        }
    };

    setAnalyticsProductIndex () {
        $('.product-list .sc-bxivhb .product-item-text-rmv').each(function (index) {
            $(this).attr('data-analytics-product-index', index);
        });
    };

    triggerRemoveProduct (removedProduct) {
        let productUrl = $('.product-detail.product-wrapper').data('variationInfo').replace('PID_PLACEHOLDER', removedProduct.skuCode);
        let nameEng = '';
        $.get({
            url: productUrl,
            success: data => {
                if (data.product && data.product.nameEng) {
                    nameEng = data.product.nameEng;
                }
                $('body').trigger('analytics:smartGiftBasketRemoveProduct', {productName: nameEng, sku: removedProduct.skuCode});
            },
            error: function () {
                $.spinner().stop();
            }
        });
    };

    enableAnalyticsBasketObserver() {
        if (SGBasket && !this.basketObserverEnabled) {
            this.basketObserverEnabled = true;
            let targetWidgetNode = $('.SGBasket-widget')[0];
            if (targetWidgetNode) {
                let config = { attributes: true, childList: true, subtree: true };
                let _self = this;
                let callback = function (mutationsList, observer) {
                    for (let index = 0; index < mutationsList.length; index++) {
                        let mutation = mutationsList[index];
                        if (mutation.type === 'attributes' &&
                            mutation.target.nodeName === 'DIV' &&
                            $(mutation.target).hasClass('showOverview') &&
                            $(mutation.target).hasClass('show') &&
                            !_self.basketAlreadyFetched) {
                            _self.basketAlreadyFetched = true;
                            _self.setAnalyticsProductIndex();
                            _self.basketBeforeRemovedProduct = _self.getBasket();
                            const clickedProduct = function (event) {
                                event.stopImmediatePropagation();
                                let productIndex = $(this).data('analyticsProductIndex');
                                let removedProduct = _self.basketBeforeRemovedProduct.splice(productIndex, 1)[0];
                                _self.triggerRemoveProduct(removedProduct);
                            };
                            $('.product-list .product-item-text-rmv').on('click', clickedProduct);
                        } else if (mutation.type === 'attributes' &&
                                mutation.target.nodeName === 'DIV' &&
                                $(mutation.target).hasClass('showOverview') &&
                                $(mutation.target).hasClass('hide')) {
                            _self.basketAlreadyFetched = false;
                        }
                    }
                };
                let observer = new MutationObserver(callback);
                observer.observe(targetWidgetNode, config);
            }
        }
    };
}

const smartGiftHelper = new SmartGiftHelper();
export default smartGiftHelper;
